import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { ISelectItems } from 'app/models/shared/shared';
import { IAdministrativeComplaintView,  IBusinessCitationView, IBusinessExemptInspectionsViewModel, ICitations, 
  IEnclosedAreaReportViewModel, IInitialResponseLettersView, IPostRemediationPlan, IRemediationViewModel, IResponseLettersView, ISiteVisitModel } from 'app/models/mainMenu/mainMenu';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

@Injectable({providedIn: 'root'})
export class MainMenuService {
  public api: string = environment.privateApi + 'MainMenu/';
  private http = inject(HttpClient);

  public unverifiedList: IAdministrativeComplaintView[] = [];
  public complaintResponseList: IResponseLettersView[] = [];
  public businessResponseList: IResponseLettersView[] = [];
  public siteVisitList: ISiteVisitModel[] = [];
  public followupVisitList: IRemediationViewModel[] = [];
  public postRemediationList: IPostRemediationPlan[] = [];
  public citationsList: ICitations[] = [];
  public annualInspectionsList: IBusinessExemptInspectionsViewModel[] = [];
  public businessEnclosedList: IEnclosedAreaReportViewModel[] = [];

  public allowedCountyList: ISelectItems[] = [];
  
  getCountyList(): Observable<string[]>{
    return this.http.get<string[]>(this.api + 'getCountyList',httpOptions);
  }

  getComplaints(county: string): Observable<IAdministrativeComplaintView[]>{
    return this.http.get<IAdministrativeComplaintView[]>(this.api + 'getData/complaints/' + county);
  }

  getResponseLetters(county: string): Observable<IResponseLettersView[]>{
    return this.http.get<IResponseLettersView[]>(this.api + 'getData/responseLetters/' + county);
  }

  getInitialResponseLetters(county: string): Observable<IResponseLettersView[]>{
    return this.http.get<IResponseLettersView[]>(this.api + 'getData/initialResponseLetters/' + county);
  }

  getSiteVisits(county: string): Observable<ISiteVisitModel[]>{
    return this.http.get<ISiteVisitModel[]>(this.api + 'getData/siteVisits/' + county);
  }

  getRemediation(county: string): Observable<IRemediationViewModel[]>{
    return this.http.get<IRemediationViewModel[]>(this.api + 'getData/remediation/' + county);
  }

  getPostRemediationPlanVisit(county: string): Observable<IRemediationViewModel[]>{
    return this.http.get<IRemediationViewModel[]>(this.api + 'getData/postRemediationPlanVisit/' + county);
  }

  getCitations(county: string): Observable<ICitations[]>{
    return this.http.get<ICitations[]>(this.api + 'getData/citations/' + county);
  }

  getExemptInspections(county: string): Observable<IBusinessExemptInspectionsViewModel[]>{
    return this.http.get<IBusinessExemptInspectionsViewModel[]>(this.api + 'getData/exemptInspections/' + county);
  }

  getEnclosedAreas(county: string): Observable<IEnclosedAreaReportViewModel[]>{
    return this.http.get<IEnclosedAreaReportViewModel[]>(this.api + 'getData/enclosedAreas/' + county);
  }

}
